<script lang="ts">
  import { appUpdate, desktop, t } from '@dabble/app';
  import { applyUpdate } from '@dabble/offline';
  import Icon from '@dabble/toolkit/Icon.svelte';
  import { tooltipBottom } from '@dabble/toolkit/tooltip';
  import { mdiArrowUpBoldCircle } from '@mdi/js';

  function relaunch(updateLocation: 'desktop' | 'web') {
    if (updateLocation === 'desktop') {
      desktop.quitAndInstall();
    } else {
      // Triggers skipWaiting on the new SW. Once it activates and claims clients,
      // the controllerchange listener in offline.ts reloads every tab. Reloading
      // here would race with cache cleanup and serve old chunk URLs that fall
      // back to the SPA shell HTML.
      applyUpdate();
    }
  }
</script>

{#if $appUpdate.state === 'downloading'}
  <div
    use:tooltipBottom={$t($appUpdate.progress ? 'update_installing_percent' : 'update_installing', {
      percent: $appUpdate.progress,
    })}
  >
    <button disabled class="icon updating-indicator">
      <Icon path={mdiArrowUpBoldCircle} />
    </button>
  </div>
{:else if $appUpdate.state === 'installed'}
  <button
    class="icon update-indicator"
    use:tooltipBottom={$t('update_installed', { version: $appUpdate.newVersion })}
    on:click={() => relaunch($appUpdate.location)}
  >
    <Icon path={mdiArrowUpBoldCircle} />
  </button>
{/if}

<style>
  :global(.app-header) button.icon.update-indicator {
    color: var(--green-dark);
    animation: app-update-ring 8s ease infinite;
  }
  :global(.app-header) button.icon.update-indicator:hover {
    color: var(--green-dark);
    animation: none;
  }

  @keyframes app-update-ring {
    0% {
      transform: scale(1);
    }
    2% {
      transform: scale(1.4);
    }
    4% {
      transform: scale(1);
    }
    6% {
      transform: scale(1.3);
    }
    8% {
      transform: scale(1);
    }
    10% {
      transform: scale(1.2);
    }
    12%,
    100% {
      transform: scale(1);
    }
  }
</style>
